"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.addAnim = exports.get = void 0;
var common_sidecar_1 = require("../../../main/common-sidecar");
var nullAction = function () { };
var _obj = null;
var get = function () {
    if (!_obj) {
        _obj = {
            isRunning: false,
            delayTimeLeft: 0,
            generator: null,
            action: nullAction,
        };
    }
    return _obj;
};
exports.get = get;
var addAnim = function (gen) {
    var obj = (0, exports.get)();
    obj.generator = gen; // TODO: queue up multiple generators
};
exports.addAnim = addAnim;
var update = function () {
    var et = common_sidecar_1.common.getUpdateDelta();
    var obj = (0, exports.get)();
    if (obj.isRunning) {
        if (obj.delayTimeLeft > 0) {
            obj.delayTimeLeft -= et;
            obj.action();
            return true;
        }
    }
    if (obj.generator) {
        obj.isRunning = true;
        var result = obj.generator.next();
        if (result.done) {
            obj.generator = null;
            obj.isRunning = false;
            return false;
        }
        if (result.value.delay) {
            obj.delayTimeLeft = result.value.delay;
        }
        if (result.value.action) {
            obj.action = result.value.action;
        }
        else {
            obj.action = nullAction;
        }
        return true; // Still running animation
    }
    return false;
};
exports.update = update;
